import { Link } from "react-router-dom";
import React from 'react';

export function Education() {
  return (
    <section className="section">
      <div id="pic">
      <h1 className="about" >Universitet</h1>
        <div className="auText" type="text">
        <p style={{ marginLeft: '60px', fontWeight: 'bold' }}>August 2021 - Ongoing:</p>
        <p style={{ marginLeft: '60px'}}>Master Of Science In Information Technology - KTH</p>
        <p style={{ marginLeft: '60px'}}>
        <span style={{ marginRight: '10px' }}>❖</span>
         Link To The Education Page:
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/utbildning/civilingenjor/informationsteknik?code=CINTE" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/utbildning/civilingenjor/informationsteknik?code=CINTE</a>
        </p>
        <p style={{ marginLeft: '60px', fontWeight: 'bold' }}>June 2022 - July 2022:</p>
        <p style={{ marginLeft: '60px'}}>Individual Course - Linköping University</p>
        <p style={{ marginLeft: '60px'}}>
        <span style={{ marginRight: '10px' }}>❖</span>
         Link To The Education Page:
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://liu.se/utbildning/kurs/ete318" target="_blank" rel="noopener noreferrer">
         https://liu.se/utbildning/kurs/ete318</a>
        </p>
        <p style={{ marginLeft: '60px', fontWeight: 'bold' }}>August 2020 - June 2021:</p>
        <p style={{ marginLeft: '60px'}}>Technical Preparatory Year - KTH</p>
        <p style={{ marginLeft: '60px'}}>
        <span style={{ marginRight: '10px' }}>❖</span>
         Link To The Education Page:
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/utbildning/teknisk-basutbildning/tekniskt-basar-60-fup" target="_blank" rel="noopener noreferrer">https://www.kth.se/utbildning/teknisk-basutbildning/tekniskt-basar-60-fup</a>
        </p>
        </div>
          <h className= "under" style={{marginLeft:110}}>Courses</h>
        <div type="text" className="auText">
        <p style={{ marginLeft: '60px'}}>
        <span style={{ marginRight: '10px' }}>❖</span>
        IE1204 Digital Design 7.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/IE1204?periods=6&startterm=20212" target="_blank" rel="noopener noreferrer">https://www.kth.se/student/kurser/kurs/IE1204?periods=6&startterm=20212</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         II1306 Introduction to IT 1.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/II1306?periods=6&startterm=20212" target="_blank" rel="noopener noreferrer">https://www.kth.se/student/kurser/kurs/II1306?periods=6&startterm=20212</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         SF1689 Basic Course in Mathematics 6.0 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/SF1689?periods=6&startterm=20212" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/SF1689?periods=6&startterm=20212</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         ID1018 Programming I 7.5 ECTS credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/ID1018?periods=6&startterm=20212" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/ID1018?periods=6&startterm=20212</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         SF1624 Algebra and Geometry 7.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/SF1624?periods=6&startterm=20212" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/SF1624?periods=6&startterm=20212</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         IS1200 Computer Engineering, Basic Course 7.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/IS1200?periods=6&startterm=20221" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/IS1200?periods=6&startterm=20221</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         SF1625 Single Variable Analysis 7.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/SF1625?periods=6&startterm=20221" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/SF1625?periods=6&startterm=20221</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         IE1206 Embedded Electronics 7.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/IE1206?periods=6&startterm=20221" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/IE1206?periods=6&startterm=20221</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         SF1610 Discrete Mathematics 7.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/SF1610?periods=6&startterm=20221" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/SF1610?periods=6&startterm=20221</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         ID1021 Algorithms and Data Structures 7.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/ID1021?periods=6&startterm=20222" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/ID1021?periods=6&startterm=20222</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         II1307 Active Career Start 1.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/II1307?periods=6&startterm=20231" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/II1307?periods=6&startterm=20231</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         IK1203 Networks and Communication 7.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/IK1203?periods=6&startterm=20231" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/IK1203?periods=6&startterm=20231</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         II1305 Project in Information and Communication Technology 7.5 ECTS credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/II1305?periods=6&startterm=20231" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/II1305?periods=6&startterm=20231</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         SF1686 Multivariable Analysis 7.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/SF1686" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/SF1686</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         Logic for Computer Scientists - DD1351
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/DD1351" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/DD1351</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         ME1003 Industrial Engineering, Basic Course 6.0 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/ME1003" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/ME1003</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         ME2016 Project Management: Leadership and Control 6.0 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/ME2016" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/ME2016</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         IV1303 Modern Software Development 6.0 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/IV1303" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/IV1303</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
        LS1415 English for Academic Studies (Online) 1.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/LS1415" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/LS1415</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         DD2350 Algorithms, Data Structures and Complexity 9.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/DD2350" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/DD2350</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         Probability Theory and Statistics 6.0 ECTS credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/SF1912" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/SF1912</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         ID1206 Operating Systems 7.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/ID1206" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/ID1206</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         DH2642 Interaction Programming and the Dynamic Web 7.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/DH2642" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/DH2642</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         AL1523 Digitalization and Innovation for Sustainable Development 7.5 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/AL1523?periods=0&l=en" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/AL1523?periods=0&l=en</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         ME2163 Leadership and Organization in Different Environments 6.0 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/ME2163" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/ME2163</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         IV1013 Introduction to Data Security 7.5 ECTS credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://www.kth.se/student/kurser/kurs/IV1013" target="_blank" rel="noopener noreferrer">
         https://www.kth.se/student/kurser/kurs/IV1013</a>
         <br></br>
         <span style={{ marginRight: '10px' }}>❖</span>
         ETE318 Fundamentals of AI 2 credits
         <br></br>
         <a style={{wordWrap: 'break-word'}}href="https://liu.se/utbildning/kurs/ete318" target="_blank" rel="noopener noreferrer">
         https://liu.se/utbildning/kurs/ete318</a>
        </p>
        </div>
        <h1 className="about" >High School</h1>
        <div className="auText" type="text">
        <p style={{ marginLeft: '60px', fontWeight: 'bold' }}>August 2016 - June 2019:</p>
        <p style={{ marginLeft: '60px'}}>Social Sciences, Behavioral Sciences – Uppsala Cathedral School</p>
        </div>

          </div>
          


      
     
    </section>
  );
}
